// Every host tab owns a URL, so switching tabs is a browser history entry (Back / Forward work).
export const TAB_PATH = {
  dashboard: "/", bod: "/bod", pipeline: "/pipeline", contracts: "/contracts", contractadmin: "/contract-admin",
  reconcile: "/reconcile", accounts: "/accounts", itbinbox: "/inbox", bidboard: "/bid-board", budget: "/budgets",
  pricelist: "/cost-library", doclibrary: "/doc-library", opsdashboard: "/ops", opsprojects: "/jobs",
  subbuilder: "/subbuilder", purchasing: "/purchasing", billing: "/billing", ar: "/ar", retention: "/retention",
  closeout: "/closeout", settings: "/settings",
};
